import { LDClient, LDContext } from 'launchdarkly-js-client-sdk';
import { createContext, useContext } from 'react';

import { emptyClient } from './empty-client';
import { FeatureFlags } from './index';

declare global {
  interface Window {
    _DATADOG_SYNTHETICS_BROWSER: boolean | undefined;
    _ldFlags?: Record<string, unknown>;
  }
}

export type FlagClient = {
  identify(context: LDContext): void;
} & Pick<LDClient, 'on' | 'off' | 'waitUntilReady'>;

type FlagContextValue = {
  client: FlagClient;
  areFlagsLoading: boolean;
  flags: FeatureFlags;
};

export const FlagContext = createContext<FlagContextValue>({
  client: emptyClient,
  areFlagsLoading: true,
  flags: {} as FeatureFlags,
});

export const useFlagClient: () => FlagClient = () => {
  return useContext(FlagContext).client;
};
